import { render, staticRenderFns } from "./LanguageField.vue?vue&type=template&id=6ff3b33f"
import script from "./LanguageField.vue?vue&type=script&lang=ts"
export * from "./LanguageField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports